import { serialize } from 'object-to-formdata';

import { AwardState } from '../../entities/awards';
import { MutateAwardAPIData } from '../../queries/awards';
import { AwardFormData, BudgetMode, MessageMode } from './types';

export const buildFormBody = (data: AwardFormData & { state?: AwardState }): MutateAwardAPIData | FormData => {
	let sendAsFormData = false;
	const filteredConditions = data.conditions.filter(({ attr, value }) => attr && value) as { attr: string; value: string }[];

	const body: MutateAwardAPIData = {
		amount: null,
		amountEditable: data.budgetMode !== BudgetMode.FixedLimit,
		approvalProcessLevels: null,
		conditions: filteredConditions,
		conditionsOperator: data.conditionsOperator,
		description: data.description,
		message: null,
		messageEditable: data.messageMode !== MessageMode.Provided,
		name: data.name,
		periodType: data.periodType,
		title: data.title,
		visibility: data.visibility,
		visibilityEditable: data.visibilityEditable,
	};

	if (data.icon instanceof File) {
		body.icon = data.icon;
		sendAsFormData = true;
	} else if (!data.icon) {
		body.icon = null;
	}

	if (data.requireApproval) {
		body.approvalProcessLevels = data.approvalLevels.map((level, index) => {
			return {
				position: index + 1,
				allowedApproverIds: level.map((user) => user.id),
			};
		});
	}

	if (data.budgetMode === BudgetMode.FlexibleLimit) {
		body.budgetPerPeriod = data.budgetPerPeriod;
	}

	if (data.budgetMode === BudgetMode.FixedLimit) {
		body.budgetPerPeriod = data.budgetPerPeriod;
		body.amount = data.amount;
	}

	if (data.budgetMode === BudgetMode.NoLimit) {
		body.budgetPerPeriod = null;
	}

	if (data.messageMode !== MessageMode.Custom) {
		body.message = data.message;
	}

	if (data.state) {
		body.state = data.state;
	}

	if (sendAsFormData) {
		return serialize(buildSnakeCasedBody(body));
	}

	return body;
};

// TODO: We should have a general case-changing utility for this.
const buildSnakeCasedBody = (body: Record<string, any>) => {
	if (typeof body === 'string') {
		return body;
	}

	const snakeCasedBody: Record<string, any> = {};
	for (const key in body) {
		const snakeCaseKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();

		if (body[key] instanceof Array) {
			snakeCasedBody[snakeCaseKey] = body[key].map((item: any) => buildSnakeCasedBody(item));
		} else if (body[key] instanceof File) {
			snakeCasedBody[snakeCaseKey] = body[key];
		} else if (body[key] instanceof Object) {
			snakeCasedBody[snakeCaseKey] = buildSnakeCasedBody(body[key]);
		} else {
			snakeCasedBody[snakeCaseKey] = body[key];
		}
	}
	return snakeCasedBody;
};
